import {darkModeSvg as Icon__small__darkModeSvg} from '../Icon__small/Icon__small--darkMode.js';

export var darkMode = {
  name: 'darkMode',
  category: 'icon',
  colorable: true,
  svg: Icon__small__darkModeSvg,
};
